// * in this file should be just the things COMMON FOR ALL of the apps in the repo

// BE endpoint URLs for different environments (app development, testing and run stages)
const DEV_BE_URL = `https://app.dev.speedlo.cloud`
const STAGE_BE_URL = `https://app.stage.speedlo.cloud`
const STAGE_BETA_BE_URL = `https://app.stage2.speedlo.cloud`
const PROD_BE_URL = `https://c2e-p1.deep-vision.cloud`

// things common for all env’s & apps
const defaultConfig = {}

// values used for a LOCAL development (localhost)
const localConfig = {
  backendUrl: DEV_BE_URL,
  storageEnvKey: `local`,
}

// values used when deployed on a DEV server/app stage
const devConfig = {
  backendUrl: DEV_BE_URL,
  storageEnvKey: `dev`,
}

// values used when deployed on a STAGE server/app stage
const stageConfig = {
  backendUrl: STAGE_BE_URL,
  storageEnvKey: `stage`,
}

// values used when deployed on a BETA STAGE server/app stage
const stageBetaConfig = {
  backendUrl: STAGE_BETA_BE_URL,
  storageEnvKey: `stage-beta`,
}

// values used when deployed on in PRODUCTION
const prodConfig = {
  backendUrl: PROD_BE_URL,
  storageEnvKey: `prod`,
}

const APP_STAGES = ['local', 'dev', 'stage', 'stageBeta', 'production'] as const

/**
 * available app run/deploy stages/environments
 * should be probably set as some ENV variable that is changed when dev/build script is run
 */
export type TAppStage = (typeof APP_STAGES)[number]

/**
 * validates that the provided string is on of TAppStage options
 */
export const isAppStage = (value: string): value is TAppStage => {
  return APP_STAGES.includes(value as TAppStage)
}

/**
 * returns config for app run/deploy stage/environment
 * this config is COMMON FOR ALL apps in the repo (no app-specific keys)
 */
export const getEnvConfig = (appStage: TAppStage) => {
  // if custom endpoint URL was provided via script param, use that (used for docker & k19s)
  const customBackendUrl =
    typeof window === `undefined`
      ? process.env.NEXT_PUBLIC_CUSTOM_ENDPOINT_SERVER
      : process.env.NEXT_PUBLIC_CUSTOM_ENDPOINT_CLIENT

  const customUrlConfig = customBackendUrl ? { backendUrl: customBackendUrl } : {}
  switch (appStage) {
    case `dev`:
      return { ...defaultConfig, ...devConfig, ...customUrlConfig }
    case `stage`:
      return { ...defaultConfig, ...stageConfig, ...customUrlConfig }
    case `stageBeta`:
      return { ...defaultConfig, ...stageBetaConfig, ...customUrlConfig }
    case `production`:
      return { ...defaultConfig, ...prodConfig, ...customUrlConfig }
    case `local`:
    default:
      return { ...defaultConfig, ...localConfig, ...customUrlConfig }
  }
}
